import { IconProps } from 'types/icon.type'

export const VisaIcon = (props: IconProps) => {
  return (
    <svg
      width="55"
      height="32"
      viewBox="0 0 55 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Visa Logo</title>
      <rect x="0.5" width="54" height="32" rx="6" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0003 21.6336H16.0579L13.8514 13.3196C13.7466 12.9372 13.5243 12.5991 13.1972 12.4397C12.3808 12.0392 11.4813 11.7205 10.5 11.5598V11.2397H15.2401C15.8943 11.2397 16.385 11.7205 16.4667 12.279L17.6116 18.2761L20.5526 11.2397H23.4134L19.0003 21.6336ZM25.0488 21.6336H22.2699L24.5582 11.2397H27.3371L25.0488 21.6336ZM30.9324 14.1191C31.0142 13.5593 31.5048 13.2392 32.0773 13.2392C32.9768 13.1589 33.9567 13.3196 34.7744 13.7187L35.2651 11.4808C34.4473 11.1607 33.5478 11 32.7315 11C30.0343 11 28.0717 12.4397 28.0717 14.4378C28.0717 15.9579 29.4619 16.7561 30.4432 17.2369C31.5048 17.7163 31.9137 18.0364 31.8319 18.5159C31.8319 19.235 31.0142 19.5551 30.1979 19.5551C29.2165 19.5551 28.2352 19.3154 27.3371 18.9149L26.8465 21.1542C27.8278 21.5532 28.8894 21.714 29.8707 21.714C32.895 21.793 34.7744 20.3546 34.7744 18.1958C34.7744 15.4771 30.9324 15.3177 30.9324 14.1191ZM44.5 21.6336L42.2934 11.2397H39.9234C39.4327 11.2397 38.9421 11.5598 38.7785 12.0392L34.6926 21.6336H37.5533L38.1243 20.1149H41.6392L41.9663 21.6336H44.5ZM40.3323 14.0388L41.1486 17.9561H38.8603L40.3323 14.0388Z"
        fill="#1434CB"
      />
    </svg>
  )
}
